export enum UserStatements {
    UserCreated = "user_created",
    ChangeUserName = "change_user_name",

    UserChanged = "user_changed",
}
